export const columns = [
  {
    label: "Name",
    value: (item) =>
      `${item?.shipping_addresses?.[0]?.first_name || ""} ${
        item?.shipping_addresses?.[0]?.last_name || ""
      }`,
  },
  {
    label: "Email",
    value: (item) => item?.email,
  },
  {
    label: "Phone Number",
    value: (item) => item?.shipping_addresses?.[0]?.phoneNumber || "",
  },
  {
    label: "Processing Fee",
    value: (item) => `${item?.transaction_fee}%`,
  },
  {
    label: "Shipping Address",
    value: (item) =>
      `${item?.shipping_addresses?.[0]?.city},${item?.shipping_addresses?.[0]?.address},${item?.shipping_addresses?.[0]?.country}`,
  },
];

export const buyercolumns = [
  {
    label: "Name",
    value: (item) =>
      `${item?.shipping_addresses?.[0]?.first_name || ""} ${
        item?.shipping_addresses?.[0]?.last_name || ""
      }`,
  },
  {
    label: "Email",
    value: (item) => item?.email,
  },
  {
    label: "Phone Number",
    value: (item) => item?.shipping_addresses?.[0]?.phoneNumber || "",
  },
  {
    label: "Shipping Address",
    value: (item) =>
      `${item?.shipping_addresses?.[0]?.city || ""} ${
        item?.shipping_addresses?.[0]?.address || ""
      } ${item?.shipping_addresses?.[0]?.country || ""}`,
  },
];
